<!-- MODAL Agregar banco -->
<div mdbModal #agregarBanco="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <form [formGroup]="formHeader" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar banco</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="agregarBanco.hide()"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <form autocomplete="off" [formGroup]="formHeader">
                        <div class="row">
                            <div class="col">
                                <div class="md-form">
                                    <mdb-select ngDefaultControl label="Banco destino" [options]="optionsBanco"
                                        placeholder="Banco destino" [filterEnabled]="true" formControlName="banco">
                                    </mdb-select>
                                    <div *ngIf="
                                        formHeader.get('banco').invalid &&
                                        (formHeader.get('banco').dirty ||
                                        formHeader.get('banco').touched)
                                        ">
                                        <mdb-error *ngIf="formHeader.get('banco').hasError('required')">
                                            Ingrese banco
                                        </mdb-error>
                                    </div>
                                </div>
                                <div class="md-form">
                                    <mdb-select ngDefaultControl label="Cuenta bancaria" [options]="optionsCuenta"
                                        placeholder="Cuenta bancaria" [filterEnabled]="true" formControlName="cuenta">
                                    </mdb-select>
                                    <div *ngIf="
                                        formHeader.get('cuenta').invalid &&
                                        (formHeader.get('cuenta').dirty ||
                                        formHeader.get('cuenta').touched)
                                        ">
                                        <mdb-error *ngIf="formHeader.get('cuenta').hasError('required')">
                                            Ingrese cuenta
                                        </mdb-error>
                                    </div>
                                </div>
                                <div class="md-form">
                                    <input value="" type="text" id="ndeposito" class="form-control"
                                        placeholder="Número de deposito" required #ndeposito
                                        formControlName="nroDeposito" onlyNumbers />
                                    <div *ngIf="
                                            formHeader.get('nroDeposito').invalid &&
                                            (formHeader.get('nroDeposito').dirty ||
                                            formHeader.get('nroDeposito').touched)
                                            ">
                                        <mdb-error *ngIf="formHeader.get('nroDeposito').hasError('required')">
                                            Ingrese nro depósito
                                        </mdb-error>
                                    </div>
                                </div>
                                <div class="md-form">
                                    <mdb-date-picker [inline]="true" name="fechaDeposito" #datePickerFechaDeposito
                                        [placeholder]="'Fecha de deposito'" required formControlName="fechaDeposito">
                                        <div *ngIf="
                                            formHeader.get('fechaDeposito').invalid &&
                                            (formHeader.get('fechaDeposito').dirty ||
                                            formHeader.get('fechaDeposito').touched)
                                            ">
                                            <mdb-error *ngIf="formHeader.get('fechaDeposito').hasError('required')">
                                                Ingrese fecha depósito
                                            </mdb-error>
                                        </div>
                                    </mdb-date-picker>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                        (click)="agregarBanco.hide()" mdbWavesEffect>Cerrar</button>
                    <button type="button" class="btn btn-success waves-light" mdbWavesEffect type="button"
                        (click)="agregar()">Agregar</button>
                </div>
            </form>
        </div>
    </div>
</div>